'use strict';

angular.module('substoreApp.services')
    .service('partnerFeatureRegistry', ['$injector', function ($injector) {

        var registry = {
            templates: {},
            actions: {}
        };

        var features = {};

        function preparePath(path) {
            var featureId = path[0];
            if (!featureId)
                return;

            // get feature service by normalized name if not already tried
            var featureId_ = featureId.toLowerCase();
            var feature = features[featureId_];
            if (!feature && (feature !== null)) {
                var serviceId = 'partnerFeature' + featureId.charAt(0).toUpperCase() + featureId.slice(1).toLowerCase();

                if ($injector.has(serviceId)) {
                    feature = features[featureId_] || $injector.get(serviceId);

                    registry.templates[featureId_] = feature.templates;
                    registry.actions[featureId_] = feature.actions;

                } else
                    features[featureId_] = null;
            }
        }

        function lookup(registry, path) {
            if (!path.length)
                return undefined;

            preparePath(path);

            var target = registry;
            for (var i = 0; i < path.length; i++) {
                if (!target)
                    return undefined;

                var arg = path[i];
                if (!arg)
                    return undefined;

                if (typeof arg !== 'string')
                    throw "illegal arguments to call of partnerFeatureRegistry (element #" + i + " on path): " + path;

                target = target[arg.toLowerCase()];
            }

            return target;
        }

        return {
            applyWithScope: function (scope, path) {
                var fn = lookup(registry.actions, path);
                if (fn === undefined)
                    return true; // no target service found; return true to signal success
                else if (typeof fn === 'function')
                    return fn(scope);
                else
                    return fn;
            },
            lookupTemplate: function (path) {
                return lookup(registry.templates, path);
            }
        };
    }]);